<template>
    <!-- 管理员-数据统计/考勤统计新（对齐考勤统计.html） -->
    <div class="attendance-summary wrapper" v-loading="loading">
        <proTitle></proTitle>

        <div class="page-header">
            <div class="page-title">考勤统计</div>
        </div>

        <div class="table_section">
            <el-form :inline="true" class="demo-form-inline flex-between" @submit.native.prevent>
                <div class="formInline-left">
                    <el-form-item>
                        <el-input v-model="formInline.keyword" size="small" clearable placeholder="搜索姓名 / 手机号 / 学校"
                            suffix-icon="el-icon-search" style="width: 220px" @input="onSearchInput"
                            @clear="onFilterChange"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="formInline.stageId" size="small" clearable placeholder="全部阶段"
                            style="width: 140px" @change="onFilterChange">
                            <el-option label="全部阶段" value=""></el-option>
                            <el-option v-for="item in stageOptions" :key="item.stageId" :label="item.stageName"
                                :value="item.stageId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="formInline-right">
                    <el-button type="primary" size="small" icon="el-icon-download" :loading="exporting"
                        @click="exportSummary">导出统计</el-button>
                </div>
            </el-form>

            <!-- 表头：序号 / 教师姓名 / 手机号 / 所在学校 / 各阶段… / 总出勤率 / 操作 -->
            <el-table :key="'summary-' + stageOptions.map(s => s.stageId).join('-')" :data="tableData" border
                style="width: 100%">
                <el-table-column type="index" label="序号" width="70" align="center"
                    :index="indexMethod"></el-table-column>
                <el-table-column prop="userName" label="教师姓名" align="center" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.userName || '--' }}</template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号" align="center" width="130" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.phone || '--' }}</template>
                </el-table-column>
                <el-table-column prop="schoolName" label="所在学校" align="center" min-width="140" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.schoolName || '--' }}</template>
                </el-table-column>
                <el-table-column v-for="stage in stageOptions" :key="'col-' + stage.stageId" :label="stage.stageName"
                    align="center" min-width="130">
                    <template slot-scope="scope">
                        <div class="attendance-cell">
                            <span class="main">
                                {{ stageDone(scope.row, stage.stageId) }}/{{ stageExpected(scope.row, stage.stageId) }}
                            </span>
                            <span class="sub">
                                上午{{ stageMorning(scope.row, stage.stageId) }} · 住宿{{ stageStay(scope.row,
                                stage.stageId) }}
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="总出勤率" align="center" width="100">
                    <template slot-scope="scope">
                        <span class="rate-badge" :class="rateClass(displayRate(scope.row))">
                            {{ formatRate(displayRate(scope.row)) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="90" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="openRecords(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-empty v-if="!loading && !stageOptions.length" description="暂无已启用阶段，请先在「阶段管理」中配置并启用阶段"></el-empty>

            <pagination v-show="stageOptions.length" :total="pages.total" :page.sync="pages.currentPage"
                :limit.sync="pages.pageSize" :pageSizes="[10, 20, 30]" @pagination="handlePageChange"></pagination>
        </div>

        <!-- 查看：全部打卡记录弹窗（不跳转考勤管理） -->
        <el-dialog custom-class="attendance-records-dialog" :title="recordsTitle" :visible.sync="recordsVisible"
            width="920px" top="6vh" :close-on-click-modal="false" @close="closeRecords">
            <div class="records-dialog-body">
                <div class="member-records-meta" v-if="currentMember">
                    <span>手机号：<strong>{{ currentMember.phone || '--' }}</strong></span>
                    <span>所在学校：<strong>{{ currentMember.schoolName || '--' }}</strong></span>
                    <span>应打卡：<strong>{{ memberRecords.length }}</strong> 次</span>
                    <span>已打卡：<strong>{{ memberCheckedCount }}</strong> 次</span>
                    <span class="meta-rate">
                        总出勤率：
                        <span class="rate-badge" :class="rateClass(memberRate)">{{ formatRate(memberRate) }}</span>
                    </span>
                </div>
                <div class="records-table-wrap">
                    <el-table v-loading="recordsLoading" :data="memberRecords" border style="width: 100%"
                        max-height="420">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column label="日期" align="center" width="130">
                            <template slot-scope="scope">{{ formatDateLabel(scope.row.expectDate) }}</template>
                        </el-table-column>
                        <el-table-column label="所属阶段" align="center" min-width="100" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.stageName || '--' }}</template>
                        </el-table-column>
                        <el-table-column label="考勤类型" align="center" min-width="110" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.attendanceTypeName || attendanceTypeLabel(scope.row.attendanceType) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="应打卡时段" align="center" width="120">
                            <template slot-scope="scope">{{ scope.row.expectTimeRange || '--' }}</template>
                        </el-table-column>
                        <el-table-column label="打卡状态" align="center" width="100">
                            <template slot-scope="scope">
                                <span class="status-badge" :class="scope.row.statusCode">
                                    {{ scope.row.statusName || '--' }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="打卡时间" align="center" width="110">
                            <template slot-scope="scope">{{ scope.row.checkTime || '--' }}</template>
                        </el-table-column>
                        <el-table-column label="打卡位置" align="center" min-width="120" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.location || '--' }}</template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" icon="el-icon-download" :loading="recordsExporting"
                    @click="exportMemberRecords">导出记录</el-button>
                <el-button size="small" @click="recordsVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { saveAs } from 'file-saver'

    export default {
        name: 'AttendanceSummary',
        data() {
            return {
                loading: false,
                exporting: false,
                stageOptions: [],
                tableData: [],
                searchTimer: null,
                formInline: {
                    keyword: '',
                    stageId: '',
                },
                pages: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
                recordsVisible: false,
                recordsLoading: false,
                recordsExporting: false,
                currentMember: null,
                memberRecords: [],
            }
        },
        computed: {
            projectId() {
                return this.$store.state.user.currentProject && this.$store.state.user.currentProject.id
            },
            recordsTitle() {
                if (!this.currentMember) return '全部打卡记录'
                return `${this.currentMember.userName || ''} · 全部打卡记录`
            },
            memberCheckedCount() {
                return this.memberRecords.filter(item => {
                    return item.statusCode === 'checked' || item.statusCode === 'late'
                }).length
            },
            memberRate() {
                if (!this.memberRecords.length) {
                    return this.currentMember ? this.currentMember.attendanceRate : 0
                }
                return this.memberCheckedCount / this.memberRecords.length
            },
        },
        methods: {
            num(value) {
                return value == null || value === '' ? 0 : Number(value) || 0
            },
            indexMethod(index) {
                return this.pages.currentPage > 1
                    ? this.pages.pageSize * (this.pages.currentPage - 1) + index + 1
                    : index + 1
            },
            rowKey(row) {
                return row.userId != null ? String(row.userId) : String(row.phone || '')
            },
            getStageStat(row, stageId) {
                const list = row.stageStats || []
                return list.find(item => String(item.stageId) === String(stageId)) || null
            },
            stageDone(row, stageId) {
                const stat = this.getStageStat(row, stageId)
                return this.num(stat && stat.doneTotal)
            },
            stageExpected(row, stageId) {
                const stat = this.getStageStat(row, stageId)
                return this.num(stat && stat.expectedTotal)
            },
            stageMorning(row, stageId) {
                const stat = this.getStageStat(row, stageId)
                return this.num(stat && stat.morningDone)
            },
            stageStay(row, stageId) {
                const stat = this.getStageStat(row, stageId)
                return this.num(stat && stat.stayDone)
            },
            // 总出勤率随阶段筛选变化（与原型一致）
            displayRate(row) {
                if (this.formInline.stageId === '' || this.formInline.stageId == null) {
                    return row.attendanceRate
                }
                const stat = this.getStageStat(row, this.formInline.stageId)
                if (!stat || !this.num(stat.expectedTotal)) return 0
                return this.num(stat.doneTotal) / this.num(stat.expectedTotal)
            },
            normalizeRate(rate) {
                if (rate == null || rate === '') return 0
                const n = Number(rate)
                if (isNaN(n)) return 0
                return n <= 1 ? Math.round(n * 100) : Math.round(n)
            },
            formatRate(rate) {
                return this.normalizeRate(rate) + '%'
            },
            rateClass(rate) {
                const n = this.normalizeRate(rate)
                if (n >= 90) return 'high'
                if (n >= 70) return 'mid'
                return 'low'
            },
            formatDateLabel(dateStr) {
                if (!dateStr) return '--'
                const parts = String(dateStr).split('-')
                if (parts.length !== 3) return dateStr
                return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`
            },
            attendanceTypeLabel(type) {
                if (Number(type) === 2) return '住宿考勤'
                if (Number(type) === 0) return '上午考勤'
                return '--'
            },
            buildQueryParams(withPage = true) {
                const params = {
                    projectId: this.projectId,
                }
                if (this.formInline.keyword) {
                    params.keyword = this.formInline.keyword.trim()
                }
                // 列表主请求不带 stageId：阶段列要全量；出勤率由前端按筛选重算
                if (withPage) {
                    params.page = this.pages.currentPage
                    params.limit = this.pages.pageSize
                }
                return params
            },
            onFilterChange() {
                this.pages.currentPage = 1
                this.fetchList()
            },
            onSearchInput() {
                if (this.searchTimer) clearTimeout(this.searchTimer)
                this.searchTimer = setTimeout(() => {
                    this.onFilterChange()
                }, 300)
            },
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex
                this.pages.pageSize = data.pageSize
                this.fetchList()
            },
            async fetchStages() {
                try {
                    const res = await this.$Api.AttendanceV2.getEnabledStages({ projectId: this.projectId })
                    this.stageOptions = Array.isArray(res.data) ? res.data : []
                } catch (e) {
                    this.stageOptions = []
                }
            },
            // 按阶段拉取汇总，拼成 stageStats（对齐原型各阶段列）
            async enrichStageStats(records) {
                if (!records.length || !this.stageOptions.length) return records
                const hasReady = records.every(row => Array.isArray(row.stageStats) && row.stageStats.length)
                if (hasReady) return records

                const keyword = (this.formInline.keyword || '').trim() || undefined
                const stageFetches = await Promise.all(this.stageOptions.map(async stage => {
                    const res = await this.$Api.AttendanceV2.getSummary({
                        projectId: this.projectId,
                        keyword,
                        stageId: stage.stageId,
                        page: 1,
                        limit: 9999,
                    })
                    return {
                        stageId: stage.stageId,
                        stageName: stage.stageName,
                        records: (res.data && res.data.records) || [],
                    }
                }))

                const byUser = {}
                stageFetches.forEach(item => {
                    item.records.forEach(row => {
                        const key = this.rowKey(row)
                        if (!byUser[key]) byUser[key] = {}
                        byUser[key][item.stageId] = {
                            stageId: item.stageId,
                            stageName: item.stageName,
                            morningDone: this.num(row.morningDone),
                            morningExpected: this.num(row.morningExpected),
                            stayDone: this.num(row.stayDone),
                            stayExpected: this.num(row.stayExpected),
                            doneTotal: this.num(row.doneTotal),
                            expectedTotal: this.num(row.expectedTotal),
                            attendanceRate: row.attendanceRate,
                        }
                    })
                })

                return records.map(row => {
                    const key = this.rowKey(row)
                    const stageStats = this.stageOptions.map(stage => {
                        return (byUser[key] && byUser[key][stage.stageId]) || {
                            stageId: stage.stageId,
                            stageName: stage.stageName,
                            morningDone: 0,
                            morningExpected: 0,
                            stayDone: 0,
                            stayExpected: 0,
                            doneTotal: 0,
                            expectedTotal: 0,
                            attendanceRate: 0,
                        }
                    })
                    return { ...row, stageStats }
                })
            },
            async fetchList() {
                if (!this.projectId) return
                if (!this.stageOptions.length) {
                    this.tableData = []
                    this.pages.total = 0
                    return
                }
                this.loading = true
                try {
                    const res = await this.$Api.AttendanceV2.getSummary(this.buildQueryParams(true))
                    const data = res.data || {}
                    const records = data.records || []
                    this.pages.total = data.total || 0
                    this.tableData = await this.enrichStageStats(records)
                } catch (e) {
                    this.tableData = []
                    this.pages.total = 0
                } finally {
                    this.loading = false
                }
            },
            async openRecords(row) {
                // 弹窗查看，不跳转考勤管理
                this.currentMember = row
                this.memberRecords = []
                this.recordsVisible = true
                this.recordsLoading = true
                try {
                    const base = {
                        projectId: this.projectId,
                        phone: row.phone,
                        page: 1,
                        limit: 9999,
                    }
                    const [detailRes, missingRes] = await Promise.all([
                        this.$Api.AttendanceV2.getDaily({ ...base, mode: 'detail' }),
                        this.$Api.AttendanceV2.getDaily({ ...base, mode: 'missing' }),
                    ])
                    const map = {}
                    const list = [
                        ...((detailRes.data && detailRes.data.records) || []),
                        ...((missingRes.data && missingRes.data.records) || []),
                    ]
                    list.forEach(item => {
                        const key = [
                            item.expectDate || '',
                            item.attendanceType,
                            item.userId || row.userId || '',
                        ].join('_')
                        map[key] = item
                    })
                    this.memberRecords = Object.values(map).sort((a, b) => {
                        const da = a.expectDate || ''
                        const db = b.expectDate || ''
                        if (da !== db) return da < db ? -1 : 1
                        return Number(a.attendanceType || 0) - Number(b.attendanceType || 0)
                    })
                } catch (e) {
                    this.memberRecords = []
                    this.$message.error('获取打卡记录失败')
                } finally {
                    this.recordsLoading = false
                }
            },
            closeRecords() {
                this.currentMember = null
                this.memberRecords = []
            },
            escapeCsv(value) {
                const str = value == null || value === '' ? '' : String(value)
                if (/[",\n\r]/.test(str)) {
                    return `"${str.replace(/"/g, '""')}"`
                }
                return str
            },
            async exportSummary() {
                if (!this.stageOptions.length) {
                    this.$message.warning('暂无已启用阶段可导出')
                    return
                }
                this.exporting = true
                try {
                    const params = {
                        projectId: this.projectId,
                        page: 1,
                        limit: 9999,
                    }
                    if (this.formInline.keyword) params.keyword = this.formInline.keyword.trim()
                    const res = await this.$Api.AttendanceV2.getSummary(params)
                    let records = (res.data && res.data.records) || []
                    records = await this.enrichStageStats(records)
                    if (!records.length) {
                        this.$message.warning('暂无数据可导出')
                        return
                    }
                    const headers = ['序号', '教师姓名', '手机号', '所在学校']
                    this.stageOptions.forEach(stage => {
                        headers.push(
                            stage.stageName + '已打卡',
                            stage.stageName + '应打卡',
                            stage.stageName + '上午',
                            stage.stageName + '住宿'
                        )
                    })
                    headers.push('总出勤率')
                    if (this.formInline.stageId !== '' && this.formInline.stageId != null) {
                        const stage = this.stageOptions.find(s => String(s.stageId) === String(this.formInline.stageId))
                        if (stage) headers.push(stage.stageName + '出勤率')
                    }
                    const rows = records.map((item, index) => {
                        const row = [index + 1, item.userName, item.phone, item.schoolName]
                        this.stageOptions.forEach(stage => {
                            const stat = this.getStageStat(item, stage.stageId) || {}
                            row.push(
                                this.num(stat.doneTotal),
                                this.num(stat.expectedTotal),
                                this.num(stat.morningDone),
                                this.num(stat.stayDone)
                            )
                        })
                        row.push(this.formatRate(item.attendanceRate))
                        if (this.formInline.stageId !== '' && this.formInline.stageId != null) {
                            row.push(this.formatRate(this.displayRate(item)))
                        }
                        return row.map(this.escapeCsv).join(',')
                    })
                    const csvContent = '\uFEFF' + [headers.join(','), ...rows].join('\n')
                    saveAs(new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }), `考勤汇总_${Date.now()}.csv`)
                } catch (e) {
                    this.$message.error('导出失败，请稍后重试')
                } finally {
                    this.exporting = false
                }
            },
            exportMemberRecords() {
                if (!this.currentMember) return
                if (!this.memberRecords.length) {
                    this.$message.warning('暂无打卡记录可导出')
                    return
                }
                this.recordsExporting = true
                try {
                    const member = this.currentMember
                    const headers = ['序号', '教师姓名', '手机号', '所在学校', '日期', '所属阶段', '考勤类型', '应打卡时段', '打卡状态', '打卡时间', '打卡位置']
                    const rows = this.memberRecords.map((item, index) => ([
                        index + 1,
                        member.userName,
                        member.phone,
                        member.schoolName,
                        item.expectDate,
                        item.stageName,
                        item.attendanceTypeName || this.attendanceTypeLabel(item.attendanceType),
                        item.expectTimeRange,
                        item.statusName,
                        item.checkTime,
                        item.location,
                    ].map(this.escapeCsv).join(',')))
                    const safeName = String(member.userName || '教师').replace(/[\\/:*?"<>|]/g, '_')
                    const csvContent = '\uFEFF' + [headers.join(','), ...rows].join('\n')
                    saveAs(
                        new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }),
                        `打卡记录_${safeName}_${Date.now()}.csv`
                    )
                } finally {
                    this.recordsExporting = false
                }
            },
        },
        async mounted() {
            if (!this.projectId) return
            this.loading = true
            try {
                await this.fetchStages()
                await this.fetchList()
            } finally {
                this.loading = false
            }
        },
        beforeDestroy() {
            if (this.searchTimer) clearTimeout(this.searchTimer)
        },
    }
</script>

<style lang="less" scoped>
    @import "../manage/less/table.less";

    .attendance-summary {
        padding: 20px 25px;
        box-sizing: border-box;

        .page-header {
            margin: 8px 0 12px;
        }

        .page-title {
            font-size: 15px;
            font-weight: 600;
            color: #303133;
        }

        .demo-form-inline {
            width: 100%;
            margin: 0 0 12px;

            .formInline-left {
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
            }

            /deep/ .el-form-item {
                margin-right: 10px;
                margin-bottom: 0;
            }
        }

        .attendance-cell {
            display: flex;
            flex-direction: column;
            align-items: center;
            line-height: 1.4;

            .main {
                font-weight: 500;
                color: #303133;
            }

            .sub {
                font-size: 12px;
                color: #909399;
            }
        }

        .rate-badge {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 10px;
            font-size: 12px;
            font-weight: 500;

            &.high {
                background: #DCFCE7;
                color: #16A34A;
            }

            &.mid {
                background: #FEF3C7;
                color: #D97706;
            }

            &.low {
                background: #FEE2E2;
                color: #DC2626;
            }
        }

        .records-dialog-body {
            display: flex;
            flex-direction: column;
            width: 100%;
            min-width: 0;
        }

        .records-table-wrap {
            width: 100%;
            min-width: 0;
            flex: 1;
        }

        .member-records-meta {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 8px 20px;
            margin-bottom: 14px;
            padding: 12px 14px;
            background: #FAFAFA;
            border-radius: 6px;
            font-size: 13px;
            color: #606266;
            width: 100%;
            box-sizing: border-box;

            strong {
                color: #303133;
                font-weight: 500;
            }

            .meta-rate {
                margin-left: auto;
            }
        }

        .status-badge {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 10px;
            font-size: 12px;
            font-weight: 500;
            white-space: nowrap;

            &.checked {
                background: #DCFCE7;
                color: #16A34A;
            }

            &.missing {
                background: #FEE2E2;
                color: #DC2626;
            }

            &.late {
                background: #FEF3C7;
                color: #D97706;
            }

            &.leave {
                background: #F3F4F6;
                color: #6B7280;
            }

            &.pending {
                background: #E0F2FE;
                color: #0284C7;
            }
        }

        .dialog-footer {
            text-align: right;
        }
    }
</style>

<style lang="less">

    /* 弹窗内容纵向排列：摘要在上、表格在下 */
    .attendance-records-dialog {
        display: flex;
        flex-direction: column;

        .el-dialog__body {
            display: flex;
            flex-direction: column;
            padding: 16px 20px;
        }

        .records-dialog-body {
            display: flex;
            flex-direction: column;
            width: 100%;
            min-width: 0;
        }

        .records-table-wrap {
            width: 100%;
            min-width: 0;
        }

        .member-records-meta {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 8px 20px;
            margin-bottom: 14px;
            padding: 12px 14px;
            background: #FAFAFA;
            border-radius: 6px;
            font-size: 13px;
            color: #606266;
            width: 100%;
            box-sizing: border-box;

            strong {
                color: #303133;
                font-weight: 500;
            }

            .meta-rate {
                margin-left: auto;
            }
        }

        .rate-badge {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 10px;
            font-size: 12px;
            font-weight: 500;

            &.high {
                background: #DCFCE7;
                color: #16A34A;
            }

            &.mid {
                background: #FEF3C7;
                color: #D97706;
            }

            &.low {
                background: #FEE2E2;
                color: #DC2626;
            }
        }

        .status-badge {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 10px;
            font-size: 12px;
            font-weight: 500;
            white-space: nowrap;

            &.checked {
                background: #DCFCE7;
                color: #16A34A;
            }

            &.missing {
                background: #FEE2E2;
                color: #DC2626;
            }

            &.late {
                background: #FEF3C7;
                color: #D97706;
            }

            &.leave {
                background: #F3F4F6;
                color: #6B7280;
            }

            &.pending {
                background: #E0F2FE;
                color: #0284C7;
            }
        }
    }
</style>
